export default __webpack_public_path__ + "static/media/logo-bottom.2ae9348f.png";